import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { makeStyles } from "@material-ui/core/styles";

import TableCell from "@material-ui/core/TableCell";
import IconButton from "@material-ui/core/IconButton";
import HomeIcon from "@material-ui/icons/Home";
import LocalOfferIcon from "@material-ui/icons/LocalOffer";
import LinkIcon from "@material-ui/icons/Link";
import InfoIcon from "@material-ui/icons/Info";
import EditIcon from "@material-ui/icons/Edit";
import Tooltip from "@material-ui/core/Tooltip";
import EmailIcon from "@material-ui/icons/Email";
import {
  setLastWorkedTicket,
  setEditingOnTicket,
  pushTicketToHistory,
  setCurrentRow,
  toggleTagModal,
  toggleInfoModal,
  toggleEmailModal,
} from "../../../../actions/projectmail";
import { defaultPasscodeTheme } from "../../../../constants/passCodeUtils";
import { EVENTMGT_ORDER_SERVER } from "../../../../constants/constants";

const useStyles = makeStyles(theme => ({
  ...defaultPasscodeTheme(theme),
  field: { padding: theme.spacing(0, 2, 0, 2) },
  pointer: {
    cursor: "pointer",
  },
  actions: {
    display: "flex",
    maxWidth: "100%",
    flexWrap: "nowrap",
  },
  edit: {
    padding: theme.spacing(0.5, 0.5, 0.5, 0.5),
    marginLeft: theme.spacing(0.5),
    marginRight: theme.spacing(0.5),
  },
  greenLine: {
    width: theme.spacing(0.5),
    marginRight: theme.spacing(1.5),
    marginLeft: theme.spacing(-2),
    backgroundColor: "#66cc33",
    minHeight: "100%",
  },
  toolTipFontSize: {
    fontSize: "0.7rem",
  },
  tooltipMargin: {
    margin: theme.spacing(0),
  },
  placeholder: {
    minWidth: theme.spacing(4),
    height: theme.spacing(3),
    margin: theme.spacing(0, 0.5),
    padding: theme.spacing(0, 0.5),
  },
}));

const TableLayoutActionsComponent = ({
  row,
  setOpenModal,
  translate,
  lastWorkedTicket,
  setLastWorkedTicketFn,
  setEditingOnTicketFn,
  username,
  pushTicketToHistoryFn,
  setCurrentRowFn,
  type,
  openTagModalFn,
  openInfoModalFn,
  openEmailModalFn,
}) => {
  const classes = useStyles();
  const url = () => {
    if (row.orderType === "webcast") return `${EVENTMGT_ORDER_SERVER}/order/myubi/index.xhtml?filter=${row.orderID}`;
    if (row.orderType === "event") return `${EVENTMGT_ORDER_SERVER}/order/ae/index.xhtml?filter=${row.orderID}`;
    return undefined;
  };

  const home = () => {
    if (row.orderID !== -1 && url() !== undefined && type !== "closed" && type !== "merged") {
      return (
        <Tooltip
          classes={{ tooltipPlacementTop: classes.tooltipMargin, tooltip: classes.toolTipFontSize }}
          title={translate.home2}
          enterDelay={500}
          placement="top"
        >
          <IconButton
            size="small"
            className={classes.edit + " " + classes.textField}
            onClick={() => window.open(url())}
          >
            <HomeIcon />
          </IconButton>
        </Tooltip>
      );
    }
    if (type !== "closed" && type !== "merged") {
      return <div className={classes.placeholder} />;
    }
    return null;
  };
  return (
    <TableCell onClick={() => setLastWorkedTicketFn(row.id)} className={`${classes.field}`} padding="none">
      <div className={classes.actions}>
        {lastWorkedTicket === row.id && <div className={classes.greenLine} />}
        <Tooltip
          classes={{ tooltipPlacementTop: classes.tooltipMargin, tooltip: classes.toolTipFontSize }}
          title={translate.info}
          enterDelay={500}
          placement="top"
        >
          <IconButton
            className={classes.edit + " " + classes.textField}
            size="small"
            onClick={() => {
              setCurrentRowFn(row);
              pushTicketToHistoryFn(row);
              openInfoModalFn();
            }}
          >
            <InfoIcon />
          </IconButton>
        </Tooltip>
        <Tooltip
          classes={{ tooltipPlacementTop: classes.tooltipMargin, tooltip: classes.toolTipFontSize }}
          title={translate.link}
          enterDelay={500}
          placement="top"
        >
          <IconButton
            size="small"
            className={classes.edit + " " + classes.textField}
            onClick={() => {
              window.open("https://zammad.ubivent.net/#ticket/zoom/" + row.id, "zammad");
              pushTicketToHistoryFn(row);
            }}
          >
            <LinkIcon />
          </IconButton>
        </Tooltip>
        <Tooltip
          classes={{ tooltipPlacementTop: classes.tooltipMargin, tooltip: classes.toolTipFontSize }}
          title={translate.linkWithAssignment}
          enterDelay={500}
          placement="top"
        >
          <IconButton
            size="small"
            className={classes.edit + " " + classes.textField}
            onClick={() => {
              if (row.owner !== "" && row.owner !== "-" && row.owner !== username) setOpenModal(true);
              else {
                setEditingOnTicketFn(row.id);
                window.open("https://zammad.ubivent.net/#ticket/zoom/" + row.id, "zammad");
                pushTicketToHistoryFn(row);
              }
            }}
          >
            <EditIcon />
          </IconButton>
        </Tooltip>
        <Tooltip
          classes={{ tooltipPlacementTop: classes.tooltipMargin, tooltip: classes.toolTipFontSize }}
          title={translate.setTags}
          enterDelay={500}
          placement="top"
        >
          <IconButton
            size="small"
            className={classes.edit + " " + classes.textField}
            onClick={() => {
              setCurrentRowFn(row);
              openTagModalFn();
              pushTicketToHistoryFn(row);
            }}
          >
            <LocalOfferIcon />
          </IconButton>
        </Tooltip>
        <div>{home()}</div>
        <Tooltip
          classes={{ tooltipPlacementTop: classes.tooltipMargin, tooltip: classes.toolTipFontSize }}
          title={translate.mailPreview}
          enterDelay={500}
          placement="top"
        >
          <IconButton
            size="small"
            className={classes.edit + " " + classes.textField}
            onClick={() => {
              setCurrentRowFn(row);
              openEmailModalFn();
            }}
          >
            <EmailIcon />
          </IconButton>
        </Tooltip>
      </div>
    </TableCell>
  );
};

TableLayoutActionsComponent.propTypes = {
  row: PropTypes.object.isRequired,
  translate: PropTypes.object.isRequired,
  setOpenModal: PropTypes.func.isRequired,
  setLastWorkedTicketFn: PropTypes.func.isRequired,
  setEditingOnTicketFn: PropTypes.func.isRequired,
  lastWorkedTicket: PropTypes.number.isRequired,
  username: PropTypes.string.isRequired,
  pushTicketToHistoryFn: PropTypes.func.isRequired,
  setCurrentRowFn: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  openTagModalFn: PropTypes.func.isRequired,
  openInfoModalFn: PropTypes.func.isRequired,
  openEmailModalFn: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  translate: state.ui.translate,
  lastWorkedTicket: state.projectmail.lastWorkedTicket,
  username: state.oauth.username,
});

const mapDispatchToProps = dispatch => ({
  setLastWorkedTicketFn: id => dispatch(setLastWorkedTicket(id)),
  setEditingOnTicketFn: id => dispatch(setEditingOnTicket(id, true)),
  pushTicketToHistoryFn: ticket => dispatch(pushTicketToHistory(ticket)),
  setCurrentRowFn: row => dispatch(setCurrentRow(row)),
  openTagModalFn: () => dispatch(toggleTagModal(true)),
  openInfoModalFn: () => dispatch(toggleInfoModal(true)),
  openEmailModalFn: () => dispatch(toggleEmailModal(true)),
});

const TableLayoutActions = connect(
  mapStateToProps,
  mapDispatchToProps
)(TableLayoutActionsComponent);

export default TableLayoutActions;
